import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "arp_admin_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem(TOKEN_KEY);
            if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    }
);

export const formatApiError = (e) => {
    const detail = e?.response?.data?.detail;
    if (!detail) return e?.message || "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((d) => (d?.msg ? d.msg : JSON.stringify(d))).join(" ");
    return String(detail);
};
